import { cEl } from '../../../../util';
import { getSubmissions } from '../../../../api/submission';
import Table, { ORDER_BY_DESC, PAGE_SIZE } from './Table';
import { getHash } from '../../../AppHeader/Link';
import SearchBox, {
    DEFAULT_SEARCH_START_OFFSET_DAYS,
    getEndOfDay,
    getStartOfDay,
    msToS,
    subtractDay,
} from './SearchBox';

function Submissions() {
    const submissionsContainer = cEl('div');
    submissionsContainer.classList.add('submissions-container');
    const param = getSubmissionsQueryParam();

    // submissionsContainer.append(Table({ size: PAGE_SIZE }));
    getSubmissions({ ...param, size: PAGE_SIZE })
        .then(res => {
            submissionsContainer.innerHTML = '';
            if (document.body.querySelector('#checkAll')) {
                document.body.querySelector('#checkAll').remove();
            }
            submissionsContainer.append(SearchBox({ param, ...res.data }));
            submissionsContainer.append(Table({ ...res.data }));
        })
        .catch(() => {
            submissionsContainer.innerHTML = '';
            if (document.body.querySelector('#checkAll')) {
                document.body.querySelector('#checkAll').remove();
            }
            submissionsContainer.append(SearchBox(param));
            submissionsContainer.append(Table({}));
        });

    return submissionsContainer;
}

export const getSubmissionsQueryParam = () => {
    const queryParam = new URLSearchParams(getHash().split('?')[1] || '');
    const page = Number(queryParam.get('page')) || 1;
    const sortColumn = queryParam.get('col');
    const direction = queryParam.get('direction');
    const startDate = queryParam.get('startDate')
        ? Number(queryParam.get('startDate'))
        : msToS(getStartOfDay(subtractDay(Date.now(), DEFAULT_SEARCH_START_OFFSET_DAYS)));
    const endDate = queryParam.get('endDate') ? Number(queryParam.get('endDate')) : msToS(getEndOfDay(Date.now()));
    const keyword = queryParam.get('keyword');

    const param = { page };
    if (sortColumn && direction) {
        param.sort = [sortColumn, direction].join();
    } else {
        param.sort = `submissionNum,${ORDER_BY_DESC}`;
    }

    if (startDate && endDate) {
        param.startDate = startDate;
        param.endDate = endDate;
    }
    if (keyword) {
        param.keyword = keyword;
    }
    return param;
};

export default Submissions;
